import React from "react";
// import ReactDOM from 'react-dom';

import { hydrate, render } from "react-dom";
//import { render } from 'react-snapshot'
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import RTL from "./components/Rtl";

const rootElement = document.getElementById("root");

//render(<RTL><App /></RTL>, rootElement);

if (rootElement.hasChildNodes()) {
  hydrate(
    <RTL>
      <App />
    </RTL>,
    rootElement
  );
} else {
  render(
    <RTL>
      <App />
    </RTL>,
    rootElement
  );
}

if (window.top.location != window.self.location) {
  window.top.location = window.self.location.href;
}

serviceWorker.unregister();
